import App from '@/views/constants/app';
import AppNavigation from '@/views/constants/app-navigation';

const state = {
  appNavigationActiveView: AppNavigation.Views.Employees
};

const getters = {
  appNavigationActiveView: state => state.appNavigationActiveView
};

const actions = {
  [AppNavigation.Actions.Navigate.DO] ({ commit }, view) {
    commit(AppNavigation.Mutations.ActiveView.SET, view);
  },

  [App.Actions.CLEAR] ({ commit }, view) {
    commit(App.Mutations.CLEAR);
  }
};

const mutations = {
  [AppNavigation.Mutations.ActiveView.SET] (state, payload) {
    state.appNavigationActiveView = payload;
  },

  [App.Mutations.CLEAR] (state) {
    state.appNavigationActiveView = AppNavigation.Views.Employees;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
